import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(browse)/layout.tsx");
